import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/results` has no view of its own — it is the step, and the step's three
 * views are its children. Overview is the one a reader lands on, so the bare
 * path resolves to it rather than rendering a fourth copy of it under a second
 * URL: two addresses for one page is what makes a shared link ambiguous.
 *
 * A REPLACE, not a push, so Back from Overview leaves the study instead of
 * bouncing through `/results` and straight back here.
 */
export const Route = createFileRoute('/_app/simops/$studyId/results/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/simops/$studyId/results/overview',
      params: { studyId: params.studyId },
      // Carried through, not dropped: `?dp=` and `?cmp=` are the reader's
      // selection, and a redirect that loses them turns a shared deep link
      // into a bare Overview.
      search: (prev) => prev,
      replace: true,
    });
  },
});
